/**
 * Ubicaciones (rc102) — hook del mapa de clientes/contratos.
 */
import { useQuery } from "@tanstack/react-query";
import { apiCall } from "@/lib/api";

export type PinUbicacion = {
  tipo: "contrato" | "cliente";
  id: string;
  codigo: string;
  lat: number;
  lng: number;
  referencia: string | null;
  estatus: string;
  cliente_id: string;
  cliente_nombre: string;
  empresa_id: number | null;
  plan_nombre: string | null;
};

export type MapaResponse = {
  fuente: "contratos" | "clientes";
  empresa_id: number | null;
  total: number;
  items: PinUbicacion[];
};

export type MapaFilters = {
  fuente: "contratos" | "clientes";
  empresaId: number | null;
  estatus: string;
};

export function useMapaUbicaciones(f: MapaFilters) {
  return useQuery({
    queryKey: ["ubicaciones", "mapa", f],
    queryFn: () => {
      const params: Record<string, string | number> = { fuente: f.fuente };
      if (f.empresaId !== null) params.empresa_id = f.empresaId;
      if (f.estatus) params.estatus = f.estatus;
      return apiCall<MapaResponse>("get", "/api/v1/ubicaciones/mapa", {
        searchParams: params,
      });
    },
    staleTime: 60_000,
  });
}
